import { render, staticRenderFns } from "./city.vue?vue&type=template&id=bbe99960&scoped=true"
import script from "./city.vue?vue&type=script&lang=js"
export * from "./city.vue?vue&type=script&lang=js"
import style0 from "./city.vue?vue&type=style&index=0&id=bbe99960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe99960",
  null
  
)

export default component.exports